import { render, staticRenderFns } from "./dataMatching.vue?vue&type=template&id=60f200b2&scoped=true&"
import script from "./dataMatching.vue?vue&type=script&lang=js&"
export * from "./dataMatching.vue?vue&type=script&lang=js&"
import style0 from "./dataMatching.vue?vue&type=style&index=0&id=60f200b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f200b2",
  null
  
)

export default component.exports